import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentListComponent } from './payment-list/payment-list.component';
import { PaymentShellComponent } from './payment-shell/payment-shell.component';
import { PaymentService } from './shared/services/payment.service';
import { PaymentLookupResolveService } from './shared/services/payment-lookup-resolve.service';
import { PaymentsRoutingModule } from './payments-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { EditPaymentComponent } from '@admin/billing/payments/edit-payment/edit-payment.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePicker } from 'primeng/datepicker';

@NgModule({
  imports: [
    CommonModule,
    PaymentsRoutingModule,
    SharedModule,
    CheckboxModule,
    DatePicker,
  ],
  providers: [PaymentService, PaymentLookupResolveService],
  declarations: [
    PaymentListComponent,
    PaymentShellComponent,
    EditPaymentComponent,
  ],
})
export class PaymentsModule {}
